<template>
  <div class="c-container">
    <balloon-dropdown
      ref="dropdown"
      :triggers="triggers"
      @touchstart.native="touchTrigger = true"
    >
      <button
        class="c-trigger c-searchCategory-button"
        slot="trigger"
        @click="searchCategoryTrigger(categories.id, categories.name)"
        @mouseenter="onMouseEnterTrigger"
      >
        <span class="category-name">
          {{ categories.name }}
        </span>
        <span
          class="arrow-right"
          v-if="!categoryId"
        >
          <coconala-icon name="chevron-right" />
        </span>
      </button>
      <button
        @click="searchCategory(categories.id, categories.name)"
        class="c-menuCaption"
        @mouseenter="currentCategoryId = categories.id"
      >{{ categories.name }}</button>
      <ul class="c-menuLv1">
        <li
          class="c-menuLv1Item"
          v-for="(category, index) in categories.subMasterCategoriesList"
          :key="index"
        >
          <button
            @click="searchCategory(category.id, categories.name)"
            class="dropdown-item"
            @mouseenter="currentCategoryId = category.id"
          >
            {{ category.name }}
          </button>
        </li>
      </ul>
    </balloon-dropdown>
  </div>
</template>
<script>
import CoconalaIcon from '~/components/atoms/CoconalaIcon'
import BalloonDropdown from '~/components/molecules/BalloonDropdown'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'searchCategorySubcategory',
  components: {
    CoconalaIcon,
    BalloonDropdown
  },
  props: {
    categoryId: {
      type: String
    },
    categories: {
      type: Object,
      default() {
        return {}
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attributes: {
        categoryId: this.categoryId
      },
      currentCategoryId: this.categories.id,
      triggers: this.categories.subMasterCategoriesList?.length > 0 ? ['hover'] : [],
      touchTrigger: false
    }
  },
  mounted() {
    this.$refs.dropdown.$el.querySelector('.dropdown-content').addEventListener(
      'mouseleave',
      () => {
        this.currentCategoryId = null
      },
      false
    )
  },
  methods: {
    async searchCategory(id = null, parentName = '') {
      await this.$store.dispatch('pages/requests/search/categoryChange', parentName)
      this.attributes.categoryId = id
      this.$emit('change', this.attributes)
    },
    onMouseEnterTrigger() {
      this.currentCategoryId = this.categories.id
    },
    searchCategoryTrigger(id = null, parentName = '') {
      // タッチデバイスの場合は検索せずバルーンを開くだけ
      if (this.touchTrigger) {
        return
      }
      this.searchCategory(id, parentName)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .dropdown {
  width: 100%;

  .dropdown-trigger {
    width: 100%;

    &::after {
      @include arrow(12px, left);
      top: 9px;
      left: 250px;
      bottom: 'auto';
      display: none;
    }
  }

  .dropdown-menu {
    left: 256px;
    top: -12px;
    width: 536px;
  }

  &-content {
    display: block;
    padding: 24px 12px;
  }

  &-item,
  .has-link {
    &.-title {
      font-size: 16px;
      padding-top: 3px;
      padding-bottom: 3px;
    }
  }
}

.c-menuCaption {
  @include link-effect;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  appearance: none;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  padding: 0 12px 8px;
  display: block;
}

.c-menuLv1 {
  width: 100%;
}

.c-menuLv1Item {
  display: inline-block;
  width: 250px;
  word-break: break-all;

  > .dropdown-item {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    outline: none;
    appearance: none;
    text-align: left;
    display: block;
    padding: 8px 12px;
    word-break: break-all;
    line-height: 1;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
